<template lang="pug">
  #error
    h2 Errrrrroooouu
    p Aconteceu um erro ao encurtar o seu link
    nav.actions
      router-link(:to="{name: 'save', params: {url: url}}") Tentar de novo
      router-link(to="/") Deixa pra lá
</template>

<script>
export default {
  name: 'ErrorScreen',
  props: ['url', 'error']
}
</script>

<style lang="stylus" scoped>
.actions
  display flex
  justify-content space-around
</style>



// WEBPACK FOOTER //
// src/components/ErrorScreen.vue